import { useState } from 'react'
import { Link } from 'react-router-dom'

import logo from '../../assets/reilm-logo.svg'
import ContactSupportPopup from '../../components/ContactSupportPopup'

const Footer = () => {
  const [supportOpen, setSupportOpen] = useState(false)
  return (
    <footer className="bg-[#EEFBE7]">
      <ContactSupportPopup open={supportOpen} onClose={() => setSupportOpen(false)} />
      <div id="company" className="max-w-canvas mx-auto px-6 md:px-[120px] pt-[40px] md:pt-[64px] pb-0 flex flex-col md:flex-row justify-between gap-12">
        <div className="flex flex-wrap gap-8 md:gap-[100px]">
          <div className="flex flex-col gap-4">
            <p className="text-[20px] leading-[32px] font-bold text-brand-dark">Product</p>
            <div className="flex flex-col gap-2 text-[16px] leading-6 text-brand-dark">
              <Link to="/pricing" className="hover:text-brand-primary transition-colors">
                Pricing
              </Link>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <p className="text-[20px] leading-[32px] font-bold text-brand-dark">Legal</p>
            <div className="flex flex-col gap-2 text-[16px] leading-6 text-brand-dark">
              <Link to="/terms" className="hover:text-brand-primary transition-colors">
                Terms
              </Link>
              <Link to="/privacy" className="hover:text-brand-primary transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>

        <div className="w-full md:w-[300px] flex flex-col gap-4 md:items-end">
          <div className="flex flex-col gap-1 md:items-end">
            <img src={logo} alt="reilm" className="w-[109px] h-[32px]" />
            <p className="text-[12px] leading-5 text-brand-dark">
              Real Estate Investments Lucrative Mode
            </p>
          </div>

          <div className="flex items-center gap-4">
            <button
              type="button"
              onClick={() => setSupportOpen(true)}
              className="h-[40px] px-5 rounded-full bg-brand-primary hover:bg-brand-hover text-white text-[14px] font-semibold transition-colors"
            >
              Contact Support
            </button>
            <div className="text-[12px] leading-4 text-brand-dark">
              <p>Monday–Friday</p>
              <p>9AM–5PM EST</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-brand-muted mt-[44px]">
        <div className="max-w-canvas mx-auto px-6 md:px-[120px] py-6">
          <p className="text-[12px] leading-5 text-brand-dark/60">
            ©2026 REILM, LLC | All rights reserved
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
